import React from "react";
import Group from "./components/group";
import Task from "./components/task";

const X1 = () => {
  return (
    <>
      <h1 className="text-4xl my-10">Task, subtasks and track manager</h1>
      <div className="min-h-screen  bg-gray-800 rounded-3xl">
        <div className="bg-gradient-to-r from-blue-700 to-green-200 rounded-t-3xl p-5 h-1"></div>
        {/* <div className="flex justify-center min-h-screen bg-gray-800 rounded-3xl pt-10"> */}
        <div className="flex text-white text-lg">
          <div className=" pt-10 h-12/12 bg-gradient-to-t from-black to-blue-700">
            <div className="cursor-pointer border-l-4 border-blue-300 pl-4 flex bg-white bg-opacity-10 py-4">
              <div className="flex-grow mr-10">Board</div>
              <div className="text-right mr-6 flex items-center">
                <svg
                  fill="currentColor"
                  height="18"
                  width="18"
                  viewBox="0 0 24 24"
                  preserveAspectRatio="xMidYMid meet"
                >
                  <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"></path>
                </svg>
              </div>
            </div>
            <div className="cursor-pointer border-l-8 border-transparent pl-4 flex hover:bg-white hover:bg-opacity-10 py-4">
              <div className="flex-grow mr-10">Team</div>
              <div className="text-right mr-6 flex items-center">
                <svg
                  fill="currentColor"
                  height="18"
                  width="18"
                  viewBox="0 0 24 24"
                  preserveAspectRatio="xMidYMid meet"
                >
                  <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"></path>
                </svg>
              </div>
            </div>
            <div className="cursor-pointer border-l-8 border-transparent pl-4 flex hover:bg-white hover:bg-opacity-10 py-4">
              <div className="flex-grow mr-10">Productivity</div>
              <div className="text-right mr-6 flex items-center">
                <svg
                  fill="currentColor"
                  height="18"
                  width="18"
                  viewBox="0 0 24 24"
                  preserveAspectRatio="xMidYMid meet"
                >
                  <path d="M10 20h4V4h-4v16zm-6 0h4v-8H4v8zM16 9v11h4V9h-4z"></path>
                </svg>
              </div>
            </div>
            <div className="cursor-pointer border-l-8 border-transparent pl-4 flex hover:bg-white hover:bg-opacity-10 py-4">
              <div className="flex-grow mr-10">Settings</div>
              <div className="text-right mr-6 flex items-center">
                <svg
                  height="18"
                  width="18"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  preserveAspectRatio="xMidYMid meet"
                >
                  <path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58a.49.49 0 00.12-.61l-1.92-3.32a.488.488 0 00-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54a.484.484 0 00-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58a.49.49 0 00-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"></path>
                </svg>
              </div>
            </div>
          </div>
          <div className="p-10" style={{ width: 800 }}>
            <div className="mb-4">
              <Task />
            </div>
            <div className="mb-4">
              <Task progressClassName="w-1/12" />
            </div>
            <div className="mb-4">
              <Task progressClassName="w-full" />
            </div>
            <div className="mb-4">
              <Task progressClassName="w-2/12" />
            </div>

            <Group title="Group 1">
              <div className="mb-4">
                <Group title="Subgroup 2">
                  <div className="mb-4">
                    <Task progressClassName="w-full" />
                  </div>
                  <div>
                    <Task progressClassName="w-2/12" />
                  </div>
                </Group>
              </div>
              <Group title="Subgroup 3">
                <div className="mb-4">
                  <Task progressClassName="w-full" />
                </div>
                <Group title="Subgroup 4">
                  <div className="mb-4">
                    <Task progressClassName="w-full" />
                  </div>
                  <div>
                    <Task progressClassName="w-2/12" />
                  </div>
                </Group>
              </Group>
            </Group>

            {/* <div className="text-gray-200 font-medium text-lg rounded-2xl flex items-center justify-center p-8 sm:p-5 bg-gradient-to-r from-blue-500 to-green-500 mt-6 sm:mt-4 cursor-pointer">
        + Add Task
      </div>
      <div className="text-gray-200 font-medium text-lg rounded-2xl flex items-center justify-center p-8 sm:p-5 bg-gradient-to-r from-indigo-500 to-purple-800 mt-6 sm:mt-4 cursor-pointer">
        + Add Group
      </div> */}
            <div className="text-gray-200 border hover:bg-white hover:bg-opacity-5 transition-colors border-gray-500 font-medium text-base rounded-2xl flex items-center duration-300 justify-center p-8 sm:p-5  mt-10 cursor-pointer">
              + Add Task
            </div>
            <div className="text-gray-200 border hover:bg-white hover:bg-opacity-5 transition-colors border-gray-500 font-medium text-base rounded-2xl flex items-center duration-300 justify-center p-8 sm:p-5  mt-6 sm:mt-4 cursor-pointer">
              + Add Group
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default X1;
